import { FaRegStar } from "react-icons/fa";
import { Link, useParams } from "react-router-dom";
import icons from "../../../database/icone";
import { useState, useEffect } from "react";
import moduleLevel from "../../../database/moduleLevel";
import domaines from "../../../database/domaines";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from "react-toastify";
import axios from "axios";
import { useStateContext } from "../../../Context/ContextProvider";
import { useSearch } from "../../../Context/SearchContext";

export default function PreparationEtp() {
    const [offlineModules, setOfflineModules] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    //zone de recherche
    const { searchTerm } = useSearch();

    const { ModuleComptesEtp } = useStateContext();

    //bg couleur selon le niveau
    const levelColors = {
        'Intermédiaire': '#ECFCCB',
        'MasterClass': '#FFE4E6',
        'Fondamentaux': '#CCFBF1',
        'Avancée': '#DBEAFE',
    };
    // couleur text selon le niveau
    const textColors = {
        'Intermédiaire': '#3F6253',
        'MasterClass': '#9F1276',
        'Fondamentaux': '#2388B6',
        'Avancée': '#4F40BC'
    }


    //const baseURL = "https://formafusionmg.ams3.cdn.digitaloceanspaces.com/formafusionmg/img/modules/";
    const baseURL = `${process.env.REACT_APP_URL_IMAGE}/`;

    const fetchModules = async () => {
        setIsLoading(true);
        try {
            const token = localStorage.getItem('ACCESS_TOKEN');
            const response = await axios.get('https://catalogue.mg.formafusion.io/api/entreprise/modules', {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    Accept: 'application/json'
                }
            });

            // Récupération des modules en préparation depuis l'API
            console.log("Réponse ETP:", response.data);
            const offlineData = response.data.offlineModules || [];
            setOfflineModules(offlineData);

        } catch (error) {
            console.error("Erreur lors de la récupération:", error);
        } finally {
            setIsLoading(false);
        }
    };

    //API get qualité
    const fetchQualityScore = async (moduleId) => {
        try {
            const token = localStorage.getItem('ACCESS_TOKEN');
            const response = await axios.get(
                `https://catalogue.mg.formafusion.io/api/entreprise/modules/${moduleId}/quality`,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Accept': 'application/json'
                    }
                }
            );
            setOfflineModules(prev => prev.map(domaine => ({
                ...domaine,
                modules: domaine.modules.map(module =>
                    module.idModule === moduleId
                        ? { ...module, qualityScore: response.data.sumQuality }
                        : module
                )
            })));
        } catch (error) {
            console.error("Erreur lors de la récupération du score qualité:", error);
            toast.error("Erreur lors de la récupération du score qualité")
        }
    };


    useEffect(() => {
        fetchModules();
    }, []);

    useEffect(() => {
        if (!isLoading) {
            offlineModules.forEach(domaine => {
                domaine.modules.forEach(module => {
                    if (!module.qualityScore) {
                        fetchQualityScore(module.idModule);
                    }
                });
            });
        }
    }, [isLoading]);

    //changement de status
    const updateStatus = async (id, action) => {
        console.log("id:", id);
        console.log("action:", action);
        try {
            const token = localStorage.getItem('ACCESS_TOKEN');
            console.log("Token utilisé :", token);
            const response = await axios.patch(`https://catalogue.mg.formafusion.io/api/entreprise/modules/${id}/${action}`, {}, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    Accept: 'application/json'
                }
            });
            if (response.status === 200) {
                // Supprimer le module restauré de l'état local
                setOfflineModules(prev =>
                    prev.map(domaine => ({
                        ...domaine,
                        modules: domaine.modules.filter(mod => mod.idModule !== id)
                    })).filter(domaine => domaine.modules.length > 0)
                );
                toast.success("Mise à jour avec succès");
                ModuleComptesEtp();
            } else {
                toast.error(response.message);
            }
        } catch (error) {
            toast.error("une erreur est survenue");
        }

    };

    return (
        <>
            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <div className="flex flex-col items-center justify-start w-full max-w-screen-xl min-h-screen mx-auto space-y-2 p-2 mt-10 sm:mt-14 lg:mt-16">
                <div className="mb-8">
                    {isLoading ? (
                        <div className="fixed inset-0 bg-black bg-opacity-20 backdrop-blur-sm z-50 flex items-center justify-center px-4">
                            {/* <div className="loader mx-auto mt-8"> </div>   */}
                            <div className="text-center">
                                <p className="text-gray-700 text-xl font-semibold ">veuillez patienter...</p>
                                <div className="flex justify-center space-x-2">
                                    <div className="w-3 h-3  animate-bounce">📚</div>
                                    <div className="w-3 h-3  animate-bounce [animation-delay:-0.2s]">📚</div>
                                    <div className="w-3 h-3  animate-bounce [animation-delay:-0.4s]">📚</div>
                                </div>
                            </div>
                        </div>
                    ) : offlineModules.length === 0 ? (
                        <div className="text-center text-gray-500 mt-8">
                            Aucun module en préparation dans l'entreprise.
                        </div>
                    ) : (
                        offlineModules
                            .filter(domaineItem => {
                                const domaineName = domaineItem.domaine || '';
                                return domaineName.toLowerCase().includes(searchTerm.toLowerCase());
                            })
                            .map((domaineItem, index) => (
                                <div key={index} className="mb-8">
                                    <div className="flex justify-between items-center w-full p-2 text-xl font-semibold bg-slate-400 rounded-lg h-10 mt-5">
                                        <h1 className="text-[15px] text-slate-950">{domaineItem.domaine || 'Domaine inconnu'}</h1>
                                        <h2 className="bg-white rounded-xl w-20 h-7 text-center text-[13px]">
                                            {domaineItem.modules?.length || 0} module{domaineItem.modules?.length !== 1 ? 's' : ''}
                                        </h2>
                                    </div>

                                    <ul className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 mt-4">
                                        {domaineItem.modules
                                            ?.filter((module) => {
                                                const name = module.module_name || module.name || '';
                                                return name.toLowerCase().includes(searchTerm.toLowerCase());
                                                // (module .module_name || module.name || '').toLowerCase().includes(searchTerm.toLowerCase());
                                            })
                                            .map((module) => {
                                                const name = module.module_name || module.name || 'Nom inconnu';
                                                const image = module.module_image || 'default.jpg';
                                                const level = module.module_level_name || moduleLevel.find((m) => m.idLevel === module.idLevel)?.module_level_name || 'Niveau inconnu';
                                                const dureeJ = module.dureeJ || module.module_dureeJ || 0;
                                                const dureeH = module.dureeH || module.module_dureeH || 0;
                                                //const prix = module.module_price || module.prix || 0;
                                                const formed = module.totalFormed || 0;
                                                const moduleId = module.idModule;
                                                const qualityScore = typeof module.qualityScore === 'number' ? module.qualityScore : 0;
                                                const qualityPercentage = Math.round((qualityScore / 6) * 100);
                                                const clampeQualityPercentage = Math.min(qualityPercentage, 100);
                                                return (
                                                    <li key={moduleId} className="w-full col-span-1 bg-white shadow-xl rounded-xl p-4 border-gray-200  border-2 group">
                                                        {/* Contenu identique au composant Catalogue */}
                                                        <div className="flex gap-10">
                                                            <figure className="h-[70px] sm:h-[80px] w-40 bg-slate-100 rounded-md overflow-hidden mb-2">
                                                                <img
                                                                    src={`${baseURL}${image}`}
                                                                    alt="Illustration"
                                                                    className="w-full h-full object-cover"
                                                                />
                                                            </figure>
                                                            <p
                                                                className=" font-bold text-[10px] sm:text-[12px] mb-1 px-2 py-0 rounded-lg h-6 flex items-center"
                                                                style={{ backgroundColor: levelColors[level], color: textColors[level] }} // couleur par défaut
                                                            >
                                                                {level}
                                                            </p>
                                                        </div>

                                                        <h2 className="text-[14px] font-semibold text-[#333] mb-1">{name}</h2>

                                                        <div className="flex items-center gap-1 mb-2 text-yellow-400">
                                                            <FaRegStar /><FaRegStar /><FaRegStar /><FaRegStar /><FaRegStar />
                                                        </div>

                                                        <p className="text-slate-500 inline-flex items-center gap-1 text-sm mb-1">
                                                            <icons.clock className="text-sm" /> {dureeJ} jours ({dureeH}h)
                                                        </p>

                                                        <div className="flex flex-col sm:flex-row sm:items-center gap-6 sm:gap-16 ">
                                                            <p className="text-slate-600 inline-flex items-center gap-2 text-sm font-medium">
                                                                <icons.users className="text-lg " />
                                                                {formed} formé{formed > 1 ? 's' : ''}
                                                            </p>

                                                            {/* <div className="flex flex-col space-y-0.5 text-sm text-slate-600">
                                                        <p className="font-semibold text-base text-slate-700">
                                                            Ar {prix}
                                                        </p>
                                                    </div> */}
                                                        </div>

                                                        {module.qualityScore !== undefined && module.qualityScore !== null ? (
                                                            <div className="relative w-48 bg-gray-400 rounded-lg h-4 overflow-hidden">
                                                                <div
                                                                    className={`h-full rounded-lg transition-all duration-300 ${clampeQualityPercentage < 30 ? 'bg-red-600' :
                                                                        clampeQualityPercentage < 70 ? 'bg-yellow-500' :
                                                                            'bg-green-500'
                                                                        }`}
                                                                    style={{ width: `${clampeQualityPercentage}%` }}
                                                                ></div>
                                                                <span className="absolute right-2 top-1/2 -translate-y-1/2 text-white text-sm font-semibold">
                                                                    {clampeQualityPercentage}%
                                                                </span>
                                                            </div>
                                                        ) : (
                                                            <span className="text-sm text-gray-500">Chargement...</span>
                                                        )}

                                                        <div className="flex items-center justify-end border-t pt-4 gap-3 mt-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                                            <Link
                                                                to={`/etp/catalogue/${moduleId}/edit`}
                                                                className="btn btn-ghost"
                                                                title="Voir les détails"
                                                                state={{ fromStatus: 'offline' }}
                                                            >
                                                                <icons.eye />
                                                            </Link>
                                                            <button className="btn btn-ghost" title="Mettre en public" onClick={() => updateStatus(module.idModule, 'online')}>
                                                                <icons.world />
                                                            </button>
                                                            <button className="btn btn-ghost" title="Mettre en corbeille" onClick={() => updateStatus(module.idModule, 'trash')}>
                                                                <icons.trash />
                                                            </button>
                                                        </div>
                                                    </li>
                                                );
                                            })}
                                    </ul>
                                </div>
                            ))
                    )}
                </div>
            </div>
        </>
    );

}